import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client'
import {setContext} from '@apollo/client/link/context'

export const API =
  process.env.NODE_ENV === 'production'
    ? `https://jeisat-backend.${window.location.host.split('.').slice(1).join('.')}`
    : 'https://jeisat-backend.namtriklab.solutions'

const httpLink = createHttpLink({
  uri: `${API}/api`,
})

const authLink = setContext((_, {headers}) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token')
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})
